import { IRootState, RootState } from '../root-state.store';
import { INotificationService, NotificationService } from '../../services';
import { ActivityStatus } from '../../common/enums';
import { HeaderNotification, IHeaderNotification, INotificationParameter } from '../../models/generic';

export interface INotificationState extends IRootState<INotificationService> {
  unreadNumber?: number;
  notifications?: {
    scrollable?: boolean
    searchParameter: INotificationParameter,
    notifications: IHeaderNotification[], activityStatus: ActivityStatus
  }
  currentChannel?: number | null;
  unreadNotifications: {
    scrollable?: boolean
    searchParameter: INotificationParameter
    notifications: IHeaderNotification[],
    activityStatus: ActivityStatus,
    unreadCount: number
    hasNewItems: number
  }
}

export class NotificationState extends RootState implements INotificationState {
  /**
   *
   */
  unreadNumber: number;
  currentChannel?: number | null;
  notifications?: {
    scrollable?: boolean
    searchParameter: INotificationParameter,
    notifications: IHeaderNotification[],
    activityStatus: ActivityStatus
  }
  unreadNotifications: {
    scrollable?: boolean
    searchParameter: INotificationParameter,
    notifications: IHeaderNotification[],
    activityStatus: ActivityStatus,
    unreadCount: number
    hasNewItems: number
  }

  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new NotificationService;
    this.unreadNumber = 0;
    this.currentChannel = null;

    this.unreadNotifications = {
      scrollable: false,
      searchParameter: {
        $limit: 30,
        $skip: 0,
        is_watched: false
      },
      activityStatus: ActivityStatus.NoActivity,
      notifications: [],
      unreadCount: 0,
      hasNewItems: 0
    }
    this.notifications = {
      scrollable: false,
      searchParameter: {
        $limit: 30,
        $skip: 0
      },
      activityStatus: ActivityStatus.NoActivity,
      notifications: [],
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/notification/notification-state.store.ts